import { Button, Tabs } from "antd";
import { FacebookFilled } from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Canhan from "./Zalo/Canhan";
import Oa from "./Zalo/Oa";

export default function ConnectZaloView() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("canhan");

    return (
        <div className="md:pl-6 flex flex-col h-full">
            {/* TITLE + SEARCH */}
            <div className="flex justify-between items-center mb-4">
                <div className="text-base font-medium">
                    {t('chats.add_zalo')}
                </div>
            </div>

            <div className="flex justify-between items-center">
                {/* TABS */}
                <Tabs
                    className="connect-tabs"
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    items={[
                        {
                            key: "canhan",
                            label: (
                                <div className="flex items-center gap-2">
                                    {t('chats.zalo_personal')}
                                </div>
                            ),
                        },
                        {
                            key: "oa",
                            label: (
                                <div className="flex items-center gap-2">
                                    Zalo OA
                                </div>
                            ),
                        }
                    ]}
                />
            </div>

            {activeTab === "canhan" && <Canhan />}
            {activeTab === "oa" && <Oa />}
        </div>
    );
}